import { NgModule } from '@angular/core';
import { PageNotFoundComponent } from 'project/pages/page-not-found/page-not-found.component';

@NgModule({
  declarations: [PageNotFoundComponent],
  exports: [PageNotFoundComponent]
})
export class PageNotFoundModule {}
